import { ReactNode } from 'react'

export interface ChartHeaderProps {
  title: string
  children?: ReactNode
}

export function ChartHeader({ title, children }: ChartHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
      <h3 className="text-base font-medium">{title}</h3>
      {children && <div className="flex flex-wrap gap-2 items-center">{children}</div>}
    </div>
  )
}

export interface ButtonGroupProps {
  options: Array<{
    value: string
    label: string
    title?: string
  }>
  value: string
  onChange: (value: string) => void
  variant?: 'primary' | 'success' | 'info'
}

export function ButtonGroup({ options, value, onChange, variant = 'primary' }: ButtonGroupProps) {
  const getActiveClass = () => {
    switch (variant) {
      case 'success':
        return 'bg-success text-white'
      case 'info':
        return 'bg-info text-white'
      default:
        return 'bg-primary text-white'
    }
  }

  return (
    <div className="flex gap-1">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          title={option.title}
          className={`px-2 py-1 text-xs rounded transition-colors ${
            value === option.value ? getActiveClass() : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
